import React from 'react'

const FirstPanel = props => (
    <svg viewBox="0 0 455.431 455.431" {...props}>
        <path
            d="M405.493 412.764c-69.689 56.889-287.289 56.889-355.556 0-69.689-56.889-62.578-300.089 0-364.089s292.978-64 355.556 0 69.689 307.201 0 364.089z"
            fill="#5ca4da"
        />
        <path
            d="M229.138 313.209c-62.578 49.778-132.267 75.378-197.689 76.8-48.356-82.489-38.4-283.022 18.489-341.333 51.2-52.622 211.911-62.578 304.356-29.867 22.755 93.867-24.178 213.333-125.156 294.4z"
            fill="#6dafe0"
        />
        <path
            d="M172.249 89.92h110.933v274.489h-58.311V142.542h-52.622V89.92z"
            fill="#fff"
        />
    </svg>
)

export default FirstPanel
